import { useRef, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Tabs } from 'shared/ui'
import { FiltersAndSearch } from 'widgets/FiltersAndSearch'
import { useBroadcastsListContext } from 'pages/broadcasts/ui/BroacastList/context'
import { BroadcastsTable } from 'pages/broadcasts/ui/BroacastList/ui/BroadcastTable/BroadcastsTable'
import { BroadcastsHeader } from 'pages/broadcasts/ui/BroacastList/ui/BroadcastsHeader/BroadcastsHeader'
import { EmptyStateBroadcasts } from './EmptyStateBroadcasts'

export enum EnumTypeBroadcast {
  all = 'All',
  rvm = 'One time',
  sms = 'One time',
  recurring = 'Recurring',
}

export const BroadcastListContent = observer(() => {
  const {
    isHideFilters,
    filtersAndSearchStore,
    dispose,
    isEmptyState,
    type,
    isOneTimePage,
    activeTabKey,
    tabs,
    handleSelectTab,
    pageLayoutStore,
    loadData,
  } = useBroadcastsListContext()
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    return () => {
      dispose()
    }
  }, [])

  useEffect(() => {
    loadData()
  }, [])

  if (isEmptyState) {
    return <EmptyStateBroadcasts />
  }

  return (
    <>
      <BroadcastsHeader
        title={`Broadcasts: ${EnumTypeBroadcast[type]}`}
        pageLayoutStore={pageLayoutStore}
      />
      {!isEmptyState && isOneTimePage && (
        <Box padding={'0 20px 12px 20px'}>
          <Tabs tabs={tabs} activeTabKey={activeTabKey} handleSelectTab={handleSelectTab} />
        </Box>
      )}
      <div
        ref={ref}
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          height: '100%',
          position: 'relative',
        }}
      >
        {!isHideFilters && <FiltersAndSearch store={filtersAndSearchStore} parent={ref.current} />}
        <BroadcastsTable />
      </div>
    </>
  )
})
